import { FileType, InventoryType } from '../constants/FileUploadConstants';
import { URLS } from '../../Shared/constants/url';

interface UploadConfig {
  helpTip: string;
  templateText: string;
  downloadLinkHref: string;
  downloadLinkText: string;
  uploadButtonLabel: string;
  type: FileType;
}

const AE_CONFIG: UploadConfig = {
  helpTip: 'upload-ae-file-helptip',
  templateText: 'upload-ae-file-template-text',
  downloadLinkHref: 'https://m.media-amazon.com/images/G/31/AdSlot/updated_template_user_allowlist.xlsx',
  downloadLinkText: 'upload-ae-file-download-link-text',
  uploadButtonLabel: 'upload-ae-file-button-label',
  type: FileType.AE,
};

const ADVERTISERS_CONFIG: UploadConfig = {
  helpTip: 'upload-rodeo-file-helptip',
  templateText: 'upload-rodeo-file-template-text',
  downloadLinkHref:
    'https://m.media-amazon.com/images/G/31/AdSlot/template_advertisers_data.xlsx',
  downloadLinkText: 'upload-rodeo-file-download-link-text',
  uploadButtonLabel: 'upload-rodeo-file-button-label',
  type: FileType.ADVERTISERS,
};

export interface InventoryUploadConfig {
  [InventoryType.CONTEXTUAL]: UploadConfig;
  [InventoryType.NON_CONTEXTUAL]: UploadConfig;
}

const INVENTORY_CONFIG: InventoryUploadConfig = {
  [InventoryType.CONTEXTUAL]: {
    templateText: 'upload-contextual-inventory-file-template-text',
    downloadLinkText: 'upload-contextual-inventory-file-download-link-text',
    downloadLinkHref:
      'https://m.media-amazon.com/images/G/31/AdSlot/template_contextual_file_format.xlsx',
    helpTip: 'upload-contextual-file-helptip',
    uploadButtonLabel: 'upload-contextual-file-button-label',
    type: FileType.CONTEXTUAL_INVENTORY,
  },
  [InventoryType.NON_CONTEXTUAL]: {
    templateText: 'upload-non-contextual-inventory-file-template-text',
    downloadLinkText: 'upload-non-contextual-inventory-file-download-link-text',
    downloadLinkHref:
      'https://m.media-amazon.com/images/G/31/AdSlot/template_non_contextual_file_format.xlsx',
    helpTip: 'upload-non-contextual-file-helptip',
    uploadButtonLabel: 'upload-non-contextual-file-button-label',
    type: FileType.NON_CONTEXTUAL_INVENTORY,
  },
};

const CATEGORY_CONFIG: UploadConfig = {
  helpTip: 'upload-category-file-helptip',
  templateText: 'upload-category-file-template-text',
  downloadLinkHref:
    'https://m.media-amazon.com/images/G/31/AdSlot/template_categoryName.xlsx',
  downloadLinkText: 'upload-category-file-download-link-text',
  uploadButtonLabel: 'upload-category-file-button-label',
  type: FileType.CATEGORY,
};

const TYPE_OF_PURCHASE_CONFIG: UploadConfig = {
  helpTip: 'upload-type-of-purchase-file-helptip',
  templateText: 'upload-type-of-purchase-file-template-text',
  downloadLinkHref:
    'https://m.media-amazon.com/images/G/31/AdSlot/template_type_of_purchase.xlsx',
  downloadLinkText: 'upload-type-of-purchase-file-download-link-text',
  uploadButtonLabel: 'upload-type-of-purchase-file-button-label',
  type: FileType.TYPE_OF_PURCHASE,
};

export const UPLOAD_CONFIGS: Record<
  string,
  UploadConfig | InventoryUploadConfig
> = {
  [URLS.ALLOWLIST]: AE_CONFIG,
  [URLS.ALLOWLIST_AE]: AE_CONFIG,
  [URLS.ALLOWLIST_INVENTORY]: INVENTORY_CONFIG,
  [URLS.ALLOWLIST_ADVERTISERS]: ADVERTISERS_CONFIG,
  [URLS.ALLOWLIST_CATEGORY]: CATEGORY_CONFIG,
  [URLS.ALLOWLIST_TYPE_OF_PURCHASE]: TYPE_OF_PURCHASE_CONFIG,
};
